/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReservationUtilizationTimePeriod } from "~/generated/graphql";

import { UtilizationChart } from "~/components/Charts";

import { isNotNil } from "~/tools";
import { useGetUtilizationData } from "../hooks";

type Props = {
  period: ReservationUtilizationTimePeriod;
  nid: string;
};

export function DefaultUtilizationChart({ nid, period }: Props) {
  const { loading, chartData, benefit, forecast, utilizationValue } =
    useGetUtilizationData({ nid, period });

  return (
    <UtilizationChart
      loading={loading}
      chartData={chartData.filter(isNotNil)}
      benefit={benefit}
      forecast={forecast}
      utilizationValue={utilizationValue}
      period={period}
    />
  );
}
